import { combineReducers } from 'redux'
import * as actions from 'actions'
import createRequestReducer from './utils/create-request-reducer'

export default combineReducers({
  updateSource: createRequestReducer([
    actions.UPDATE_SOURCE,
    actions.UPDATE_SOURCE_ERROR,
    actions.UPDATED_SOURCE
  ])
})



// WEBPACK FOOTER //
// ./reducers/requests.js